import { render, staticRenderFns } from "./BrandsAndCharacteristicsPageAdmin.vue?vue&type=template&id=0ba98b05"
import script from "./BrandsAndCharacteristicsPageAdmin.vue?vue&type=script&lang=js"
export * from "./BrandsAndCharacteristicsPageAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports